import { createTypes, asyncType, createNS } from '@/utils/actionCreator';

export const NS = createNS('LOGIN');

export const ActionTypes = createTypes([...asyncType('LOGIN'), 'RESET'], NS);

export default ActionTypes;
